import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import MutationEmployeeBookingStatus from 'graphql/mutations/MutationEmployeeBookingStatus'
import { bookingStatusActive } from 'utils/constants/booking-constants'
import { constantsActive } from 'utils/constants/constants'

export default class MutateEmployeeBooking {

	static status = ( guids, status, { callbackSuccess = null, callbackError = null, callbackStart = null } ) => {
		const graphqlBuilder = new GraphqlBuilder();
		
		const active = _.includes( [ ...bookingStatusActive ], status );
		
		_.forEach( guids, guid => {
			graphqlBuilder.addQuery( `mutation-booking-status-${guid}`, MutationEmployeeBookingStatus, {
				guid: guid,
				active: active ? constantsActive.YES : constantsActive.NO,
				status: status
			});
		})
		
		graphqlBuilder.setOnStart( callbackStart )
		graphqlBuilder.setOnError( callbackError );

		graphqlBuilder.setOnSuccess( result => {
			const bookings = _.map( result, o => {
				return _.get( o, ['booking_cancel', 'employee_booking'], {} );
			});
			
			if( _.isFunction( callbackSuccess ) ) {
				callbackSuccess({
					bookings
				});
			}
		})
		

		graphqlBuilder.execute();
	}
}
